module.exports = __webpack_public_path__ + "img/2-exterior-wall.ad0e3979.svg";